/**
 * 画像モードの URL 組み立て（純関数）。
 *
 * 署名は接頭辞 1 本（サーバの DerivedPaths::signedPrefix）。配下のどの成果物も
 * 同じクエリを付けるだけで取得できる — タイルは 1 ページで数百枚になり、URL ごとに
 * 署名を配ることが現実的でないため。ページ粒度の認可は署名の scope 側で担保される。
 *
 * 文法（サーバと共有する契約）:
 *   {base}/{page}/view.{fmt}
 *   {base}/{page}/full.{fmt}
 *   {base}/{page}/tiles/{level}/{col}_{row}.{fmt}
 *   {base}/{page}/thumb.jpg
 */
import type { PageUrls } from '../../core/manifest';

function url(urls: PageUrls, pageNo: number, suffix: string): string {
  const path = `${urls.base}/${pageNo}/${suffix}`;
  return urls.query ? `${path}?${urls.query}` : path;
}

/** 下地（表示・めくり用）。全ページに必ずある。 */
export function viewUrl(urls: PageUrls, pageNo: number, format: string): string {
  return url(urls, pageNo, `view.${format}`);
}

/** 拡大用の単一画像。タイルを持たないページにだけある。 */
export function fullUrl(urls: PageUrls, pageNo: number, format: string): string {
  return url(urls, pageNo, `full.${format}`);
}

export function tileUrl(
  urls: PageUrls,
  pageNo: number,
  level: number,
  col: number,
  row: number,
  format: string,
): string {
  return url(urls, pageNo, `tiles/${level}/${col}_${row}.${format}`);
}

/** サムネイルは形式固定（サーバが pdftoppm で直接 JPEG を出す）。 */
export function thumbUrl(urls: PageUrls, pageNo: number): string {
  return url(urls, pageNo, 'thumb.jpg');
}

/** この環境で表示できる形式を、サーバが持っている形式の中から選ぶ（先頭が優先）。 */
export function pickFormat(formats: readonly string[], canWebp: boolean): string {
  const usable = formats.filter((format) => format !== 'webp' || canWebp);
  return usable[0] ?? 'jpg';
}
